import * as React from "react";
import type { SVGProps } from "react";

const FacilityToilet = React.memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    {...props}
  >
    <path
      d="M7.50005 10.8333H16.2501C16.9404 10.8333 17.5001 10.2737 17.5001 9.58333C17.5001 8.89298 16.9404 8.33333 16.2501 8.33333H7.50005M7.50005 10.8333L3.33346 10.8333C2.87322 10.8333 2.50013 10.4602 2.50013 10M7.50005 10.8333L7.50013 3.33333C7.50013 2.8731 7.12703 2.5 6.6668 2.5H3.33346C2.87322 2.5 2.50013 2.8731 2.50013 3.33333V10M2.50013 10L2.5 10.6981C2.5 12.2718 3.50703 13.669 5 14.1667V17.5C5 17.9602 5.3731 18.3333 5.83333 18.3333H12.266C12.5226 18.3333 12.7649 18.2151 12.9229 18.0128C13.0808 17.8106 13.1367 17.5468 13.0745 17.2979L12.5 15L12.5995 14.9751C14.5001 14.5 15.8333 12.7924 15.8333 10.8333"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
FacilityToilet.displayName = "FacilityToilet";

export default FacilityToilet;
